import apiClient from '@/plugins/axios'

export default {
  getFornecedores(filter) {
    return apiClient.post('fornecedor/index', filter)
  },

  getFornecedor(id) {
    return apiClient.get(`fornecedor/${id}`)
  },

  getCpfCnpj(cpfcnpj) {
    return apiClient.get(`fornecedor/getcpfcnpj/${cpfcnpj}`)
  },

  postFornecedor(fornecedor) {
    return apiClient.post(`fornecedor`, { fornecedor })

  },

  putFornecedor(id, fornecedor) {
    return apiClient.put(`fornecedor/${id}`, { fornecedor })

  },

  deleteFornecedor(id) {
    return apiClient.delete(`fornecedor/${id}`)

  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Fornecedor/_services/FornecedorService.js